<template>
	<CCard>
		<CCardHeader> Recherche de client </CCardHeader>
		<CCardBody>
			<CRow>
				<CCol col="12">
					<find-customer v-on:selection="onSelection" />
				</CCol>
			</CRow>

			<hr />

			<CRow>
				<CCol col="6">
					<b>Création d'un compte client</b>
					<CInput v-model="email" name="email" label="E-mail" />
				</CCol>
				<CCol col="12">
					<GLoadingButton color="primary" label="Créer" class="d-inline" @click="onSubmit" />
				</CCol>
			</CRow>
		</CCardBody>
	</CCard>
</template>

<script>
	import FindCustomer from './find-customer';
	import GLoadingButton from '../../../../../components/ghostlexly-components/GLoadingButton';

	export default {
		name: 'create-or-find-customer',
		components: {
			GLoadingButton,
			FindCustomer,
		},

		props: {
			customerId: String,
		},

		data() {
			return {
				loading: false,
				email: null,
			};
		},

		methods: {
			onSelection(data) {
				this.$axios.get(data).then(res => {
					this.$emit('update:customerId', res.data.owner);
					this.$emit('update:addressId', data);
				});
			},

			async onSubmit() {
				// check if user account exists before creating it
				let tryLogin = await this.$axios.get(`/api/users?email=${this.email}`).then(res => {
					if (res.data['hydra:totalItems'] === 1) {
						this.$emit('update:customerId', res.data['hydra:member'][0]['@id']);
						return true;
					} else {
						return false;
					}
				});

				if (tryLogin) {
					return true;
				}

				// create user
				this.$axios.post('/api/users', { email: this.email }).then(res => {
					this.$emit('update:customerId', res.data['@id']);
				});
			},
		},
	};
</script>
